import { render } from "./Hero.vue?vue&type=template&id=6878cd06&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=6878cd06&lang=scss&scoped=true"

import exportComponent from "D:\\Development\\JS\\SeptaCode\\septacode.com\\demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6878cd06"]])

export default __exports__